import React, { useState, useEffect, useRef } from 'react';
import './LoadingState.css';

// Adım süreleri kademeli olarak uzuyor, gerçek bir işlem gibi hissettirsin.
// Son adımın süresi yok: API yanıtı gelene kadar orada bekler.
const STEPS = [
  { label: 'Yapay zeka analiz ediyor...', duration: 3000 },
  { label: 'CV ve tercihler değerlendiriliyor...', duration: 4500 },
  { label: 'Uygun pozisyonlar taranıyor...', duration: 5500 },
  { label: 'Sonuçlar sıralanıyor...', duration: null },
];

// Çubuk %95'e asimptotik yaklaşır, asla dolmaz, iş bitmeden "tamamlandı"
// izlenimi vermemesi için
const TARGET = 95;
const EASING = 0.025;
const TICK_MS = 120;

const LoadingState = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [progress, setProgress] = useState(0);
  const timerRef = useRef(null);

  // Adım ilerlemesi
  useEffect(() => {
    const duration = STEPS[currentStep]?.duration;
    if (!duration) return undefined; // son adım: beklemeye devam

    timerRef.current = setTimeout(() => {
      setCurrentStep((prev) => Math.min(prev + 1, STEPS.length - 1));
    }, duration);

    return () => clearTimeout(timerRef.current);
  }, [currentStep]);

  // İlerleme çubuğu
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => (prev >= TARGET - 0.5 ? prev : prev + (TARGET - prev) * EASING));
    }, TICK_MS);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-state">
      <div className="loading-state__bar">
        <div className="loading-state__bar-fill" style={{ width: `${progress}%` }} />
      </div>
      <div className="loading-state__steps">
        {STEPS.map((step, i) => (
          <div
            key={i}
            className={`loading-state__step ${i <= currentStep ? 'loading-state__step--active' : ''} ${i === currentStep ? 'loading-state__step--current' : ''}`}
          >
            <div className="loading-state__dot" />
            <span>{step.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadingState;
